import { createFileRoute } from "@tanstack/react-router";
import { RouteError } from "../../../shared/components/RouteError";
import { RoutePending } from "../../../shared/components/RoutePending";

/**
 * @purpose Edit one bike model's specs
 * @primary Bike model form
 * @persona paola-admin-belora
 */
export const Route = createFileRoute("/app/c/$customerSlug/bike-models/$id/")({
  errorComponent: ({ error }) => <RouteError error={error} />,
  pendingComponent: RoutePending,
});
